<template>
  <div class="columns is-multiline">
    <b-loading :is-full-page="true" :active.sync="isLoading" :can-cancel="true"></b-loading>
    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <!-- <a @click="goTo('content')" class="button is-light is-radiusless">&lt; Back</a> -->
          <a @click="toggleInstructions()" class="button is-dark is-radiusless">Ayuda</a>
        </div>
        <form class="has-text-left">
          <div class="card-content">
            <h3 class="is-size-3">{{initTitle}}</h3>
            <br>
            <div class="columns is-multiline">
              <b-field label="Archivo*" class="column is-12">
                <!-- <b-upload v-model="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"> -->
                <b-upload v-model="file">
                  <a class="button is-warning is-radiusless">
                    <span>Clic para buscar</span>
                  </a>
                </b-upload>
                <span class="file-name" v-if="file">
                  {{ file.name }}
                </span>
              </b-field>
            </div>
          </div>
          <div class="card-footer">
            <button type="button" class="button is-warning is-radiusless" @click="submit()">Enviar</button>
          </div>
        </form>
      </div>
    </section>

    <section class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Archivos cargados</h3>
          <b-table :data="table.data" :striped="true" :hoverable="true" :paginated="true" :per-page="8">
            <template slot-scope="props">
              <b-table-column field="narchivo" label="Nombre archivo" sortable>
                  {{ props.row.archive_name }}
              </b-table-column>
              <b-table-column field="rango" label="Fecha subida" sortable>
                  {{ props.row.initial_date }} to {{ props.row.final_date }}
              </b-table-column>
              <b-table-column field="nombre" label="Nombre fundación" sortable>
                  {{ props.row.nit }} {{ props.row.name }}
              </b-table-column>
              <b-table-column field="retencion" label="Retencion" sortable>
                  {{ props.row.rete }}
              </b-table-column>
              <b-table-column field="totalbase" label="Valor Total Base" sortable>
                  {{ props.row.base }}
              </b-table-column>
              <b-table-column field="totalrete" label="Valor Total Retención" sortable>
                  {{ props.row.retentation }}
              </b-table-column>
              <b-table-column field="actions" label="Acciones" sortable>
                <a class="button is-danger is-radiusless" @click="deletea(props.row.id)">
                  <font-awesome-icon :icon="['fa','times']"/></a>
                <a class="button is-success is-radiusless" @click="generateExcel(props.row.archive_name)">
                  <font-awesome-icon :icon="['fa','file-excel']"/></a>
              </b-table-column>
            </template>
          </b-table>
        </div>
      </div>
    </section>
    <!-- help -->
    <section v-if="needHelp" class="info-tiles column is-12">
      <div class="card">
        <div class="card-header">
          <a @click="toggleInstructions()" class="button is-light is-radiusless">X Cerrar ayuda</a>
        </div>
        <div class="card-content">
          <h3 class="is-size-3">Ayuda</h3>
          <p class="is-size-6">
            Una <b>Entrada</b> es un espacio para importar la información de retención de un excel.
          </p>
          <hr>
          <h3 class="is-size-4">Instrucciones</h3>
          <ul>
              <li>- Campos con (*) son requeridos</li>
              <li>- La extensión disponible para archivos es (xlsx)</li>
            </ul>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import VueCkeditor from 'vue-ckeditor2'
import env from '@/env'
import ArchivesService from '@/services/ArchivesService'
import { xMisc } from '@/mixins/xMisc.js'
import { sGate } from '@/mixins/sGate.js'
export default {
  name: 'dashboard',
  mixins: [xMisc, sGate],
  components: {
    VueCkeditor
  },
  data () {
    return {
      isLoading: false,
      file: null,
      needHelp: false,
      helpText: 'Ayuda',
      initTitle: 'Subir archivo',
      table: {
        data: []
      }
    }
  },
  mounted () {
    this.fetchData()
  },
  methods: {
    async fetchData () {
      var archives = await ArchivesService.fetchArchives(this.$session.get('user').token)
      for (var i = 0; i < archives.data.length; i++) {
        this.table.data.push(archives.data[i])
      }
    },
    async submit () {
      if (this.file == null) {
        this.alert('danger', 'Error, Debe Cargar un archivo')
      } else {
        let formData = new FormData()
        formData.append('file', this.file)
        var response = await ArchivesService.validateFiles(formData, this.$session.get('user').token)
        this.openLoading()
        console.log(response.data.success)
        if (response.data.success === true) {
          this.closeLoading()
          this.save(formData)
        } else {
          this.closeLoading()
          var errores = response.data.data
          if (errores === 'error') {
            this.confirmCustom2()
          } else {
            this.confirmCustom(errores, formData)
          }
        }
      }
    },
    async deleteData (id) {
      var response = await ArchivesService.delArchive({id: id}, this.$session.get('user').token)
      if (response.data.success) {
        this.$toast.open({
          message: 'Archivo eliminado',
          type: 'is-success'
        })
        // unset data
        var s = this.table.data.length
        for (var i = s - 1; i >= 0; i--) {
          if (this.table.data[i].id === id) {
            this.table.data.splice(i, 1)
          }
        }
      } else {
        this.alert('danger', 'Error, Intente nuevamente')
      }
    },
    deletea (id) {
      this.$dialog.confirm({
        title: 'Eliminando archivo',
        message: 'Estas seguro que quieres <b>eliminar</b> este archivo?',
        confirmText: 'Eliminar archivo',
        cancelText: 'Cancelar',
        type: 'is-danger',
        onConfirm: () => this.deleteData(id)
      })
    },
    toggleInstructions () {
      if (this.needHelp) {
        this.needHelp = false
        this.helpText = 'Ayuda'
      } else {
        this.needHelp = true
        this.helpText = 'Cerrar ayuda'
      }
    },
    async save (formData) {
      this.openLoading()
      var response = await ArchivesService.uploadFiles(formData, this.$session.get('user').token)
      if (response.data.success) {
        this.file = null
        this.$toast.open({
          message: 'Información guardada correctamente',
          type: 'is-success'
        })
        this.table.data = []
        this.fetchData()
      }
      this.closeLoading()
    },
    openLoading () {
      this.isLoading = true
    },
    closeLoading () {
      this.isLoading = false
    },
    confirmCustom (errores, formData) {
      this.$dialog.confirm({
        title: 'Error, ¿Quieres continuar?',
        message: errores,
        cancelText: 'No',
        confirmText: 'Si',
        type: 'is-success',
        onConfirm: () => this.save(formData)
      })
    },
    confirmCustom2 () {
      this.$dialog.alert({
        title: 'Error',
        message: 'El archivo ya se encuentra en la base de datos',
        type: 'is-danger',
        hasIcon: true,
        icon: 'times',
        iconPack: 'fa'
      })
    },
    async generateExcel (archive) {
      window.open(env.API_BASE_URL + '/outputs/EXCEL/null/null/null/null' + '/' + archive + '/null', '_blank')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/input/Input.vue